import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomFilterTable } from 'src/app/models/custom-filters/custom-filter-table.model';
import { CustomFiltersTabletService } from 'src/app/services/custom-filters-tablet.service';
@Component({
    selector: 'app-custom-filter',
    templateUrl: './custom-filter.component.html',
    styleUrls: ['./custom-filter.component.scss'],
    standalone: false
})
export class CustomFilterComponent {
  private customFilters: CustomFilterTable[] = [];
  get customFiltersTable() { return this.customFilters; }
  @Input()
  set customFiltersTable(customFiltersTable: CustomFilterTable[]) {
    if (customFiltersTable && customFiltersTable.length > 0) {
      this.customFilters = customFiltersTable;
      this.activateFilter();
    }
  }

  @Output() selectedCustomFilter = new EventEmitter();

  constructor(
    public readonly customFiltersTableService: CustomFiltersTabletService
  ) {
    this.customFilters = customFiltersTableService.customFiltersTable;
  }
  clearFilter() {
    this.customFiltersTable.forEach(filter => {
      filter.FiltersList = [];
    });
    this.selectedCustomFilter.emit(this.customFiltersTable);
  }

  hideFilters() {
    this.clearFilter();
    this.customFiltersTableService.activateFilters = false;
  }

  activateFilter() {
    for (const filter of Object.values(this.customFiltersTable)) {
      if (filter.FiltersList.length !== 0) {
        this.customFiltersTableService.activateFilters = true;
        break;
      }
    }
  }

  onActivateFilter() {
    this.customFiltersTableService.activateFilters = true;
  }

}


